import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumericValue } from 'utils/general';

import { useGetUpcomingInvoice } from '@/modules/payment/apiHooks';
import { Typography } from '@/shared/components/atoms';

const UpcomingInvoiceCard = () => {
  const { t } = useTranslation('payment');
  const { data } = useGetUpcomingInvoice();

  return (
    <div className='flex h-full w-full flex-col gap-11 rounded-xl border-xs border-neutralVariant-90 bg-background-neutral-99 p-24 '>
      {data ? (
        <>
          <div className='flex flex-col gap-2'>
            <div className='flex justify-between gap-2'>
              <div className='flex flex-col'>
                <Typography
                  variant='body1'
                  weight='semiBold'
                  className='text-text-default'
                >
                  {t('next-invoice')}
                </Typography>
                <Typography variant='body2' className='text-surface-10'>
                  {t(`${data?.currency}-sign`)}{' '}
                  {data?.paymentPlan
                    ? data?.paymentPlan.interval === 'year'
                      ? formatNumericValue(data?.paymentPlan.price / 12)
                      : data?.paymentPlan.price
                    : 0}{' '}
                  {t('per-field')}, {t('per-month')}
                </Typography>
              </div>
              <div className='flex flex-col'>
                <Typography
                  variant='h2'
                  weight='semiBold'
                  className='text-text-default'
                >
                  {t(`${data?.currency}-sign`)}
                  {data?.amount ?? 0}
                </Typography>
                <Typography variant='body2' className='text-surface-10'>
                  {t('total-bill')}
                </Typography>
              </div>
            </div>
            <div className='w-fit rounded-lg bg-outline-default py-1 px-2 text-primary-400'>
              {data?.paymentPlan?.numberOfFields ?? 0} {t('fields')}
            </div>
          </div>
          <div className='flex items-center gap-1 text-base'>
            <span className='text-surface-10'>{t('invoice-issue-date')}</span>
            <span className='text-text-default'>
              {data?.date ? format(new Date(data?.date), 'MMM dd, yyyy') : '-'}
            </span>
          </div>
        </>
      ) : (
        <div className='flex h-full w-full items-center justify-center'>
          {t('no-upcoming-invoices')}
        </div>
      )}
    </div>
  );
};

export { UpcomingInvoiceCard };
